import React from 'react';
import InformationToolTip from './InformationToolTip';

const TextAreaField = ({title, required, register, errors,tooltip,tooltipType, ...props}) => {
    let reg = register || {}
    const {[reg.name]: error} = errors || {};
    return (
        <div className={register ? "padding-top" : ""}>
            <p className="text-input-label font-size-medium">
                {title}{" "}
                {tooltip && <InformationToolTip tooltipType={tooltipType}/>}
                {required && <i className="required padding-right-smallest">*</i>}
            </p>
            <div className="field-format">
                <textarea {...register} {...props}/>
            </div>
            {error && <p className='text-color-red font-bold'> {error.message} </p>}
        </div>
    );
};

export default TextAreaField;